function playMusic(target) {
  const doc = document;

  target.play();

  const wxReady = () => {
    target.play();
    doc.removeEventListener('WeixinJSBridgeReady', wxReady, false);
  }

  const touchend = () => {
    target.play();
    doc.removeEventListener('touchend', touchend, false);
  }

  doc.addEventListener('WeixinJSBridgeReady', wxReady, false);
  doc.addEventListener('touchend', touchend, false);
}

export function createMusic() {
  const jukebox = new Image();
  jukebox.src = require(`images/music.png`);
  jukebox.classList.add("music");

  const audio = document.createElement('audio');
  audio.src = './music.mp3';
  audio.loop = true;

  const section = document.createElement('section');
  section.appendChild(jukebox);
  section.appendChild(audio);

  playMusic(audio);

  jukebox.onclick = function () {
    jukebox.classList.contains('stop') ? audio.play() : audio.pause();
    jukebox.classList.contains('stop') ? jukebox.classList.remove('stop') : jukebox.classList.add('stop');
  }
  document.body.appendChild(section);
}